const base = require("./base");
module.exports = {
  ...base.apiFactory("/"),
  _chat_190606: "https://test-frontend.cjdropshipping.com/chat/",
  /** Whop App View 引导页「去授权」落点域名(测试环境), 取法见 app/controller/whopAppView.js */
  _whop_authorize_origin_260922: "http://www.cjdropshipping.offline.pre.com",
  _phone_190606: "http://m.cjdropshipping.offline.pre.com/",
  "productSku": "https://cj-oss-test.oss-cn-hangzhou.aliyuncs.com/", // 商品详情数据测试环境oss地址
  "productDetail": "https://cj-oss-test.oss-cn-hangzhou.aliyuncs.com/", // 商品详情数据测试环境oss地址
  "supplierInfo": "https://cj-oss-test.oss-cn-hangzhou.aliyuncs.com/", // 供应商信息oss地址
};
